import React, { Component } from 'react'

// ui
import Modal from '../../components/feedback/modal'
import Button from '../../components/uielements/button'

// redux
import { connect } from 'react-redux'
import mediaActions from '../../redux/qbmedia/actions'

class ModalConfirmDelete extends Component {
    _handleOK = () => {
        this.props.deleteMedia(this.props.media.media_id)
        this.props.dismiss()
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    render() {
        const { visible } = this.props
        return (
            <Modal
                visible={visible}
                title="Xác nhận xoá tài liệu"
                onOk={() => this._handleOK()}
                onCancel={() => this._handleCancel()}
                centered
                footer={[
                    <Button 
                        style={{ backgroundColor: '#b3e6ff' }}
                        onClick={() => this._handleCancel()}
                    >
                        Không
                    </Button>,
                    <Button
                        style={{ backgroundColor: '#ff9999' }}
                        onClick={() => this._handleOK()}
                    >
                        Xoá
                    </Button>,
                ]}
            >
                <p>Bạn có chắc chắn xoá tài liệu này không?</p>
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        visible: state.qbmedia.modalConfirmDeleteMedia,
        media: state.qbmedia.currentMedia
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(mediaActions.action.dismissModalConfirmDeleteMedia())
        },
        deleteMedia: id => {
            dispatch(mediaActions.action.deleteMedia(id))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ModalConfirmDelete)
